// extracted by mini-css-extract-plugin
module.exports = {"actions":"Actions_actions__1g9kU","list":"Actions_list__2K4Bw","favorite":"Actions_favorite__3izH0","button":"Actions_button__3SG8H"};